import api from 'lib/Api'

const handleIntegration = ({ integrationId, objectId }) => {
  api.get(`/dynamic_integrations/${integrationId}/execute`, { object_id: objectId })
}

export default handleIntegration
